<template>
  <!--权限管理页面-->
  <div id="authorityList">
    <div class="allTablePlace">
      <div>
        <button @click="addNewPro" class="redButtonTwo">新建产品组</button>
      </div>
      <div class="authorityBody">
        <div class="authorityleft">
          <nav class="authorityNav">产品组列表</nav>
          <div>
            <ul>
              <li @click="selectRoles(index)" v-for="(item, index) in roleMenu" :key="index" :class="selectIndex === index ? 'onClickli' : ''">
                <abbr style="width: calc(100% - 20px);display: inline-block">{{item.name}}</abbr>
                <i  @click="removeProduct(item, index)" class="m_l_5 font16 colorCH" style="color:#ee1100">×</i>
              </li>
            </ul>
          </div>
        </div>
        <div style="width: 25%" class="authorityCent">
          <nav class="authorityNav">用户列表</nav>
          <p class="p_r d_i" style="width: calc(100% - 30px);padding:0 10px">
            <input  @input="searchUser" class="allInput menuUserSearch onlyInput" type="text" placeholder="姓名,工作邮箱" style="width:calc(100% - 20px);padding: 5px 20px 5px 5px;">
            <i class="icon iconfont iconsousuo p_a colorRed alldw" style="right: 8px;top:7px;"></i>
          </p>
          <div v-if="roleMenu[selectIndex] && roleMenu[selectIndex].productUsers" class="horSpan" style="width: calc(100% - 20px)">
            <span :class="index === userSelectIndex ? 'activeUser' : ''" :key="index" v-for="(item, index) in roleMenu[selectIndex].productUsers" class="delSpan userList" :title="item.userName">
              <abbr class="NoWrap d_i" style="width: calc(100% - 20px)">{{item.userName}} - {{item.email}}</abbr><i @click="removeSelectUser(index)" class="m_l_5 font16 colorCH" style="color:#ee1100">×</i>
            </span>
          </div>
          <div @click="addNewUser" class="addSubmenu m_t_10" style="background-color: #F9FAFB">+添加用户</div>
        </div>
        <div style="width: 55%" class="authorityleft">
          <nav class="authorityNav">分类列表</nav>
          <div>
            <ul>
              <li style="display: inline-block;background-color: #FAFAFA;border-radius: 5px;margin: 5px" v-for="(item, index) in cateList" :key="index">{{item.name}}</li>
            </ul>
          </div>
        </div>
        <userPicker v-on:choosedConfirm="confirUserPicker($event)" v-model="showUserPicker"></userPicker>
      </div>
      <model v-if="newModel" :buttonType="0" :title="'新建产品组'" :minWidth="'500px'" v-on:on-cancel="newModel = false" v-on:on-confirm="confirModel()" >
        <div style="overflow-y: hidden;">
          <ul class="allUL">
            <li><span>产品组名称</span> <abbr>
              <!-- <input style="width: 50%" class="allInput" v-model="productModel.name" type="text"> -->
              <allSelect :width="300" style="display: inline-block" :chooseData="prodOptions" :needReturn="'bU_BrandId'"
                :placeholder="'请选择'" :matchValue="'name'" :showValue="'{{name}}'" v-model="productModel.brandBUId">
              </allSelect>
            </abbr>
          </li>
            <li>
              <span>产品组用户</span>
              <abbr>
                <button @click="showUserPicker2 = true" class="redButtonTwo">请选择</button>
              </abbr>
            </li>
            <li>
              <span style="vertical-align: top">已选列表</span>
              <abbr style="display: inline-block;width: 60%;white-space: normal">
                <b :key="index" v-for="(item, index) in productModel.productUsers" style="display:inline-block;margin: 5px;padding: 8px 12px;border-radius: 5px;background-color: #fafafa">
                  <span>{{item.userName}}</span>
                  <i @click="removeSelectUser2(index)" class="m_l_5 c_p font16 colorCH" style="color:#ee1100">×</i>
                </b>
              </abbr>
            </li>
          </ul>
        </div>
      </model>
    </div>
    <userPicker v-on:choosedConfirm="confirNewUserPicker($event)" v-model="showUserPicker2"></userPicker>
  </div>
</template>

<script>
export default {
  name: 'authorityList',
  data () {
    return {
      newModel: false,
      roleMenu: [
      ],
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      groupFlag: false,
      userList: [],
      cateList: [],
      selectIndex: 0,
      userSelectIndex: '',
      showUserPicker: false,
      showUserPicker2: false,
      // allGroupsList: [],
      allNewAdmins: [],
      orginMenuList: [],
      allCateList: [],
      productModel: {
        brandBUId: '',
        productUsers: [],
        name:'',
        nameEN:''
      },
      prodOptions:[]
    }
  },
  created () {
    this.getAllProDuct()
    this.getProdOptions()
  },
  methods: {
    removeProduct (item, index) {
      this.$commonJs.doubleComfirm({
        content: '确定删除此产品组？',
        successFun: msg => {
          this.$axiox.del('/api/product/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.roleMenu.splice(index, 1)
            this.selectIndex = 0
          })
        },
        errorFun: msg => {
        }
      })
    },
    addNewPro () {
      // this.newModel = true
      this.productModel = {
        brandBUId: '',
        productUsers: [],
        name:'',
        nameEN:''
      }
      this.getProdOptions(true)
    },
    confirModel () {
      if (!this.productModel.brandBUId) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择产品组名称',
          stayTime: 5
        })
        return
      }
      const brandBUId = this.productModel.brandBUId
      const findByBrandId = (brandId) => this.prodOptions.find(item => item.bU_BrandId === brandId);
      const myitems = findByBrandId(brandBUId)
      this.productModel.name = myitems.name
      this.productModel.nameEN = myitems.nameEN


      this.$axiox.post('/api/product/Add', this.productModel).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '添加成功',
          stayTime: 5
        })
        this.newModel = false
        this.getAllProDuct()
      })
    },
    getAllCate () {
      this.$axiox.get('/api/product/cateGory/querybyProduct/' + this.roleMenu[this.selectIndex].id).then(p => {
        this.cateList = p
        this.resetProductList()
      })
    },
    inportUser () {
      let file = document.getElementById('userFile').files[0]
      let res = this.$commonJs.uploadFileWX(file)
      console.log(res)
    },
    getAllProDuct () {
      this.$axiox.get('/api/product/query?PageIndex=1&PageSize=9999').then(p => {
        this.roleMenu = p
        this.getAllCate()
      })
    },
    getProdOptions(type){
      
      this.$axiox.get('/api/BUController/select/List').then(p => {
        this.prodOptions = p
        if(type){
          this.newModel = true
        }
      })
      
    },
    resetProductList () {
      for (let i = 0; i < this.roleMenu.length; i++) {
        this.roleMenu[i].cateList = []
        for (let j = 0; j < this.allCateList.length; j++) {
          if (this.roleMenu[i].id === this.allCateList[j].productId) {
            this.roleMenu[i].cateList.push(this.allCateList[j])
          }
        }
      }
      console.log(this.roleMenu)
    },
    editGroupsConfirm () {
      let groupIdList = []
      // for (let i = 0; i < this.allGroupsList.length; i++) {
      //   if (this.allGroupsList[i].checked) {
      //     groupIdList.push(this.allGroupsList[i].id)
      //   }
      // }
      for (let i = 0; i < this.totalmenuList.length; i++) {
        if (this.totalmenuList[i].checked) {
          groupIdList.push(this.totalmenuList[i].id)
        }
      }
      let data = {
        roleId: this.roleMenu[this.selectIndex].id,
        menuIds: groupIdList
      }
      this.$axiox.put('/api/authoritymenu/CreateRoleMenuMapping/CreateRoleMenuMapping', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.groupFlag = false
      })
    },
    returnEidtFlag (index) {
      this.groupFlag = false
      this.totalmenuList = JSON.parse(JSON.stringify(this.orginMenuList))
      // this.chooseGroup(index)
    },
    groupsEditMode () {
      this.groupFlag = true
      this.orginMenuList = JSON.parse(JSON.stringify(this.totalmenuList))
    },
    getAllGroups () {
      if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 0) {
        let data = {
          status: 1,
          pageIndex: 1,
          pageSize: 99999
        }
        let url = this.$commonJs.returnQuery('/api/contentType/all', data)
        this.$axiox.get(url).then(msg => {
          this.allGroupsList = msg.result.items
          for (let i = 0; i < this.allGroupsList.length; i++) {
            this.$set(this.allGroupsList[i], 'checked', false)
          }
        })
      } else {
        let data = {
          pageIndex: 1,
          pageSize: 99999
        }
        let url = this.$commonJs.returnQuery('/api/Group/group', data)
        this.$axiox.get(url).then(msg => {
          this.allGroupsList = msg.result.items
          for (let i = 0; i < this.allGroupsList.length; i++) {
            this.$set(this.allGroupsList[i], 'checked', false)
          }
        })
      }
    },
    selectRoles (index) {
      this.selectIndex = index
      this.userSelectIndex = ''
      this.getAllCate()
      // this.$axiox.get('/api/authoritymenu/GetAllMenusByRole/rolemenus?roleId=' + this.roleMenu[this.selectIndex].id).then(msg => {
      //   console.log(msg)
      //   this.menuList = msg
      //   for (let i = 0; i < this.totalmenuList.length; i++) {
      //     this.$set(this.totalmenuList[i], 'checked', false)
      //     for (let j = 0; j < this.menuList.length; j++) {
      //       if (this.totalmenuList[i].id === this.menuList[j].id) {
      //         this.$set(this.totalmenuList[i], 'checked', true)
      //       }
      //     }
      //   }
      //   // if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 3) {
      //   // this.getAllGroups()
      //   // }
      // })
      // this.$axiox.get('/api/employeerole/GetEmps?roleId=' + this.roleMenu[this.selectIndex].id).then(msg => {
      //   this.userList = msg
      //   for (let i = 0; i < this.userList.length; i++) {
      //     this.$set(this.userList[i], 'checked', false)
      //   }
      //   // if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 3) {
      //   // this.getAllGroups()
      //   // }
      //   this.groupFlag = false
      // })
    },
    searchUser (e) {
      console.log(e.target.value)
      let domList = document.querySelectorAll('.userList')
      if (domList) {
        console.log(this.roleMenu[this.selectIndex])
        for (let i = 0; i < domList.length; i++) {
          if (this.roleMenu[this.selectIndex].productUsers[i].userName.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0 || this.roleMenu[this.selectIndex].productUsers[i].email.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
            console.log(1)
            domList[i].style.display = 'inline-block'
          } else {
            console.log(2)
            domList[i].style.display = 'none'
          }
        }
      }
    },
    addNewUser () {
      this.showUserPicker = true
    },
    confirNewUserPicker (e) {
      let data = e.chooseUserList
      let newList = []
      for (let i = 0; i < data.length; i++) {
        let flag = true
        for (let j = 0; j < this.productModel.productUsers.length; j++) {
          if (data[i].employeeId === this.productModel.productUsers[j].userId) {
            flag = false
          }
        }
        if (flag) {
          let newData = {
            userId: data[i].employeeId,
            productId: this.roleMenu[this.selectIndex].id,
            userName: data[i].chineseName,
            email: data[i].email
          }
          newList.push(newData)
        }
      }
      this.productModel.productUsers = this.productModel.productUsers.concat(newList)
    },
    confirUserPicker (e) {
      console.log(e)
      let data = e.chooseUserList
      let newList = []
      let postData = JSON.parse(JSON.stringify(this.roleMenu[this.selectIndex]))
      for (let i = 0; i < data.length; i++) {
        let flag = true
        for (let j = 0; j < postData.productUsers.length; j++) {
          if (postData.productUsers[j].userId === data[i].employeeId) {
            flag = false
          }
        }
        if (flag) {
          let newData = {
            userId: data[i].employeeId,
            // userId: 'test',
            productId: this.roleMenu[this.selectIndex].id,
            userName: data[i].chineseName,
            email: data[i].email
            // userName: 'test'
          }
          newList.push(newData)
        }
      }
      postData.productUsers = postData.productUsers.concat(newList)
      console.log(postData)
      // let data = {
      //   role: this.roleMenu[this.selectIndex].replace(' ', ''),
      //   userIds: e.chooseUserIdList
      // }
      this.$axiox.post('/api/product/Update', postData).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '添加成功',
          stayTime: 5
        })
        this.$set(this.roleMenu, this.selectIndex, postData)
        // this.roleMenu[this.selectIndex] = postData
      })
    },
    chooseGroup (index) {
      // console.log(this.allGroupsList)
      this.userSelectIndex = index
      // for (let i = 0; i < this.allGroupsList.length; i++) {
      //   this.$set(this.allGroupsList[i], 'checked', false)
      // }
      this.groupFlag = false
      if (this.selectIndex === 1 || this.selectIndex === 0) {
        this.$axiox.post('/api/authoritymenu/GetAllMenusByUser/usermenus', {userId: this.userList[index].id}).then(msg => {
          // for (let i = 0; i < this.allGroupsList.length; i++) {
          //   let flag = false
          //   this.$set(this.allGroupsList[i], 'checked', false)
          //   for (let j = 0; j < msg.result.editorTypes.length; j++) {
          //     if (this.allGroupsList[i].typeName === msg.result.editorTypes[j].typeName) {
          //       flag = true
          //     }
          //   }
          //   if (flag) {
          //     this.allGroupsList[i].checked = true
          //   }
          // }
          for (let i = 0; i < this.menuList.length; i++) {
            let flag = false
            this.$set(this.menuList[i], 'checked', false)
            for (let j = 0; j < msg.result.editorTypes.length; j++) {
              if (this.menuList[i].name === msg.result.editorTypes[j].typeName) {
                flag = true
              }
            }
            if (flag) {
              this.menuList[i].checked = true
            }
          }
        })
      }
      if (this.selectIndex === 2) {
        this.$axiox.get('/api/contentType/fromuser/' + this.userList[index].userId).then(msg => {
          for (let i = 0; i < this.allGroupsList.length; i++) {
            let flag = false
            this.$set(this.allGroupsList[i], 'checked', false)
            for (let j = 0; j < msg.result.ownerTypes.length; j++) {
              if (this.allGroupsList[i].typeName === msg.result.ownerTypes[j].typeName) {
                flag = true
              }
            }
            if (flag) {
              this.allGroupsList[i].checked = true
            }
          }
        })
      }
      if (this.selectIndex === 3) {
        for (let i = 0; i < this.allGroupsList.length; i++) {
          let flag = false
          this.$set(this.allGroupsList[i], 'checked', false)
          let adminsList = this.allGroupsList[i].admins.split(',')
          console.log(adminsList)
          for (let j = 0; j < adminsList.length; j++) {
            if (this.userList[this.userSelectIndex].userName === adminsList[j]) {
              flag = true
            }
          }
          if (flag) {
            this.allGroupsList[i].checked = true
          }
        }
      }
    },
    removeSelectUser2 (index) {
      this.productModel.productUsers.splice(index, 1)
    },
    removeSelectUser (index) {
      this.$commonJs.doubleComfirm({
        content: '确定删除此用户？',
        successFun: msg => {
          let postData = JSON.parse(JSON.stringify(this.roleMenu[this.selectIndex]))
          postData.productUsers.splice(index, 1)
          console.log(postData)
          // let data = {
          //   role: this.roleMenu[this.selectIndex].replace(' ', ''),
          //   userIds: e.chooseUserIdList
          // }
          this.$axiox.post('/api/product/Update', postData).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.$set(this.roleMenu, this.selectIndex, postData)
            // this.roleMenu[this.selectIndex] = postData
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>

<style scoped>
  .horSpan span.activeUser{
    background-color: #ee1100;
    color: #fff;
  }
  .addSubmenu{
    padding:5px 10px;
    margin: 0 10px;
    border-color: #ee1100;
    border-radius: 4px;
    color:#ee1100;
  }
  .cancelButtonTwo{
    border-color: #ee1100;
    color:#ee1100;
  }
  .authorityNav{
    padding: 10px;
    color: #8C8C8C;
    font-size: 16px;
  }
  .authorityBody{
    min-height: 750px;
  }
  .authorityBody > div{
  display: inline-block;
  vertical-align: top;
  }
  .authorityleft{
    width: calc(20% - 10px);
  }
  .authorityleft > div{
    max-height: 600px;
    overflow: auto;
  }
  .authorityleft > div ul {
    padding:10px;
  }
  .authorityleft > div ul li{
    text-align: center;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .onClickli{
    background-color: #ee1100;
    color: white;
    border-radius: 4px;
  }
  .onClickli i{
    color: #fff!important;
  }
  .redButton{
    color: #ee1100;
    background-color: #ee1100;
  }
  .redButtonTwo{
    background-color: #ee1100;
    border-radius: 4px;
  }
  .authorityCent{
    width: calc(20% - 10px);
    background-color: #FAFAFA;
    min-height: 580px;
  }
  .authorityCentTwo{
    width: 80%;
    background-color: #FAFAFA;
    min-height: 750px;
  }
  .authorityRight{
    width: 60%;
  }
  .horSpan{
    white-space: normal;
    overflow: auto;
    padding: 10px;
    width: calc(100% - 20px);
    max-height: 600px;
  }
  .allTable td{
    padding: 10px;
    padding-left: 50px !important;
  }
  .allTable th{
    border-bottom-color: #ee1100;
    padding: 10px;
    padding-left: 50px !important;
  }
  .horSpan span{
    display: inline-block;
    padding: 10px 15px;
    background-color: #EFEFEF;
    border-radius: 4px;
    cursor: pointer;
    margin: 5px;
    white-space: nowrap;
  }
  .delSpan{
    width: calc(100% - 20px);
    padding:10px 5px!important;
  }
  @media screen and (max-width: 1370px) {
    .onlyInput {
      padding: 5px 15px !important;
      width: calc(100% - 20px) !important;
    }
    .alldw {
      top: 25%!important;
      right: 0px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/productList.vue